export class Key {
    public static ESC: number = 27;
    public static ENTER: number = 13;
    public static ARROW_LEFT: number = 37;
    public static ARROW_UP: number = 38;
    public static ARROW_RIGHT: number = 39;
    public static ARROW_DOWN: number = 40;
}
